import { Node } from '@tiptap/core'

export const VariableNode = Node.create({
  name: 'variable',
  group: 'inline',
  inline: true,
  atom: false,

  addAttributes() {
    return {
      name: {
        default: '',
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-variable]',
        getAttrs: (dom) => ({
          name: dom.getAttribute('data-variable'),
        }),
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      {
        'data-variable': HTMLAttributes.name,
        contenteditable: 'false',
        class: 'variable',
      },
      `{{${HTMLAttributes.name}}}`,
    ]
  },

  toText({ node }: { node: { attrs: { name: string } } }) {
    return `{{${node.attrs.name}}}`
  },
})
